import { ref, watch, onScopeDispose } from "vue";

export function useCountUp(targetRef, options = {}) {
  const duration = options.duration ?? 900;
  const enabledRef = options.enabled;
  const from = options.from ?? 0;

  const current = ref(0);
  let rafId = null;
  let startTime = 0;
  let startValue = 0;
  let endValue = 0;

  function easeOutCubic(p) {
    return 1 - Math.pow(1 - p, 3);
  }

  function cancel() {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function start() {
    cancel();
    const target = Number(targetRef.value) || 0;
    startValue = from;
    endValue = target;
    startTime = performance.now();

    const tick = (now) => {
      const elapsed = now - startTime;
      const p = Math.min(1, elapsed / duration);
      const eased = easeOutCubic(p);
      current.value = startValue + (endValue - startValue) * eased;
      if (p < 1) {
        rafId = requestAnimationFrame(tick);
      } else {
        current.value = endValue;
        rafId = null;
      }
    };
    rafId = requestAnimationFrame(tick);
  }

  function reset() {
    cancel();
    current.value = 0;
  }

  function isEnabled() {
    if (!enabledRef) return true;
    if (typeof enabledRef === "function") return Boolean(enabledRef());
    return Boolean(enabledRef.value);
  }

  watch(
    () => [Number(targetRef.value) || 0, isEnabled()],
    ([, enabled]) => {
      if (enabled) {
        start();
      } else {
        reset();
      }
    },
    { immediate: true }
  );

  onScopeDispose(cancel);

  return { current, start, reset };
}
